import { render } from "./commonPopup.vue?vue&type=template&id=2ceaa8fa&scoped=true"
import script from "./commonPopup.vue?vue&type=script&lang=js"
export * from "./commonPopup.vue?vue&type=script&lang=js"

import "./commonPopup.vue?vue&type=style&index=0&id=2ceaa8fa&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceaa8fa"]])

export default __exports__